import { Dispatch } from "redux";
import React from "react";

interface Props {
    functionGroupModalRef: React.RefObject<HTMLDivElement | null>;
    qualificationStandardModalRef: React.RefObject<HTMLDivElement | null>;
    isFunctionGroupModalOpen: boolean;
    isQualificationStandardModalOpen: boolean;
    setIsFunctionGroupModalOpen: (isOpen: boolean) => {
        type: string;
        payload: boolean;
    };
    setIsQualificationStandardModalOpen: (isOpen: boolean) => {
        type: string;
        payload: boolean;
    };
    dispatch: Dispatch;
    event: MouseEvent;
}

export const handleTagClickOutside = (props: Props): void => {
    const {
        functionGroupModalRef,
        qualificationStandardModalRef,
        isFunctionGroupModalOpen,
        isQualificationStandardModalOpen,
        setIsFunctionGroupModalOpen,
        setIsQualificationStandardModalOpen,
        dispatch,
        event,
    } = props;

    if (
        functionGroupModalRef.current &&
        !functionGroupModalRef.current.contains(event.target as Node) &&
        isFunctionGroupModalOpen
    ) {
        dispatch(setIsFunctionGroupModalOpen(false));
    }

    if (
        qualificationStandardModalRef.current &&
        !qualificationStandardModalRef.current.contains(event.target as Node) &&
        isQualificationStandardModalOpen
    ) {
        dispatch(setIsQualificationStandardModalOpen(false));
    }
};
